import { TopUpModule as ParentTopUpModule } from '../index'
import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  step: 'amountSelect',
  topUpData: null,
  topUpSelected: ['auto']
}

const AutoTopUpModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async deactivateAutoTopUp ({ commit, state }, { nextStep }) {
      commit('clearMessages', {}, { root: true })

      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeAutoTopUp {
          deactivateAutoTopUp{
            activationPossible,
            active,
            topUp {
              amount,
              trigger,
              type
            }
          }
        }`
      }).then((response) => {
        state.step = nextStep
        commit('Transaction/removeTransactionId', 'changeAutoTopUp', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async changeAutoTopUp ({ commit, state, getters }, { nextStep }) {
      commit('clearMessages', {}, { root: true })

      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeAutoTopUp ($changeAutoTopUpInput: ChangeAutoTopUpInput!) {
          changeAutoTopUp (autoTopUp: $changeAutoTopUpInput){
            activationPossible,
            active,
            topUp {
              amount,
              trigger,
              type
            }
          }
        }`,
        variables: {
          changeAutoTopUpInput: {
            amount: state.topUpData.amount,
            trigger: state.topUpData.trigger ? state.topUpData.trigger : 2,
            type: getters.selectType(state.topUpData.type)
          }
        }
      }).then((response) => {
        state.step = nextStep
        commit('Transaction/removeTransactionId', 'changeAutoTopUp', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    reset (state) {
      Object.assign(state, initialState)
    },
    changeStep (state, { step }) {
      state.step = step
    },
    storeSelection (state, { topUpData, topUpSelected }) {
      state.topUpData = topUpData
      state.topUpSelected = topUpSelected
    }
  },
  getters: {
    selectType: ParentTopUpModule.getters.selectType,
    currentStep: (state) => {
      return state.step
    },
    selectedTopUpData (state) {
      return state.topUpData
    },
    selectedTopUp (state) {
      return state.topUpSelected
    }
  }
}

export {
  AutoTopUpModule
}
